import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Radio from 'aquilla/core/atoms/Radio/Radio';
import RadioGroup from 'aquilla/core/atoms/Radio/RadioGroup';

const Container = styled.div``;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
  font-size: ${Fonts.H6};
  flex-wrap: wrap;
  ${mediaQuery.uptoMobile} {
    & .aquilla-typography {
      font-weight: ${Fonts.SEMIBOLD};
    }
    gap: 28px;
  }
`;

const RadioButton = ({
  options,
  selected = [],
  onChange,
  filterName,
  filterType
}) => {
  if (!options?.length) return null;

  return (
    <>
      <Container>
        <StyledRadioGroup
          name={`store-${filterName}`}
          value={selected[0]}
          onChange={() => {}}
          className="radio-option"
        >
          {options.map((option) => (
            <div
              key={option.code}
              role="button"
              tabIndex={option.code}
              onClick={() =>
                onChange({ value: option.code, filterName, filterType })
              }
              onKeyDown={() => {}}
            >
              <Radio value={option.code}>{option.label}</Radio>
            </div>
          ))}
        </StyledRadioGroup>
      </Container>
    </>
  );
};

export default RadioButton;
